export const TELEGRAM_LOGIN_START_PARAM = "is_telegram_1";
// Deep links из кнопок бота «Настроить VPN» / «Продлить подписку»:
// start_param = guide_<subscription_id> или renew_<subscription_id>
export const TELEGRAM_GUIDE_PREFIX = "guide_";
export const TELEGRAM_RENEW_PREFIX = "renew_";
// Кнопка «Детальное руководство»: страница всех руководств по подписке
export const TELEGRAM_GUIDE_ALL_PREFIX = "guideall_";
const TELEGRAM_AUTO_LOGIN_HANDLED_KEY = "autoLoginHandled";

export function getTelegramDeepLink() {
  const startParam = getTelegramStartParam();
  if (!startParam) {
    return null;
  }
  if (startParam.startsWith(TELEGRAM_GUIDE_ALL_PREFIX)) {
    return {
      page: "guide_all",
      subscriptionId: startParam.slice(TELEGRAM_GUIDE_ALL_PREFIX.length),
    };
  }
  if (startParam.startsWith(TELEGRAM_GUIDE_PREFIX)) {
    return {
      page: "guide",
      subscriptionId: startParam.slice(TELEGRAM_GUIDE_PREFIX.length),
    };
  }
  if (startParam.startsWith(TELEGRAM_RENEW_PREFIX)) {
    return {
      page: "renew",
      subscriptionId: startParam.slice(TELEGRAM_RENEW_PREFIX.length),
    };
  }
  return null;
}

// Путь в приложении, куда ведёт deep link из бота; null — обычный вход.
export function getTelegramTargetPath() {
  const deepLink = getTelegramDeepLink();
  if (!deepLink || deepLink.subscriptionId === "") {
    return null;
  }
  if (deepLink.page === "guide") {
    return `/account/guide/${encodeURIComponent(deepLink.subscriptionId)}`;
  }
  if (deepLink.page === "guide_all") {
    return `/account/guide/${encodeURIComponent(deepLink.subscriptionId)}/all`;
  }
  return `/account/subscription?sub=${encodeURIComponent(deepLink.subscriptionId)}`;
}

export function getTelegramStartParam() {
  try {
    const startParam = window.Telegram?.WebApp?.initDataUnsafe?.start_param;
    if (startParam) {
      return startParam;
    }
  } catch {}

  const initParams = getMiniappInitData();
  const tgWebAppData = initParams.tgWebAppData;
  if (!tgWebAppData) {
    return null;
  }
  return new URLSearchParams(tgWebAppData).get("start_param");
}

export function markTelegramAutoLoginHandled() {
  sessionStorageSet(TELEGRAM_AUTO_LOGIN_HANDLED_KEY, true);
}

function isTelegramAutoLoginHandled() {
  return sessionStorageGet(TELEGRAM_AUTO_LOGIN_HANDLED_KEY) === true;
}

function isTelegramAutoLoginTriggered(searchParams) {
  if (searchParams?.get("is_telegram") === "1") {
    return true;
  }
  const startParam = getTelegramStartParam();
  if (startParam === TELEGRAM_LOGIN_START_PARAM) {
    return true;
  }
  return getTelegramDeepLink() != null;
}

export function clearTelegramLoginSearchParam(searchParams, setSearchParams) {
  if (!searchParams?.has("is_telegram")) {
    return;
  }

  setSearchParams(
    (prev) => {
      const next = new URLSearchParams(prev);
      next.delete("is_telegram");
      return next;
    },
    { replace: true },
  );
}

export function isTelegramLoginRequested(searchParams) {
  if (isTelegramAutoLoginHandled()) {
    return false;
  }
  return isTelegramAutoLoginTriggered(searchParams);
}

export default function getMiniappInitData() {
  var locationHash = "";
  try {
    locationHash = window.location.hash.toString();
  } catch (e) {}

  var initParams = urlParseHashParams(locationHash);
  var storedParams = sessionStorageGet("initParams");
  if (storedParams) {
    for (var key in storedParams) {
      if (typeof initParams[key] === "undefined") {
        initParams[key] = storedParams[key];
      }
    }
  }
  sessionStorageSet("initParams", initParams);
  return initParams;
}

function urlParseHashParams(locationHash) {
  locationHash = locationHash.replace(/^#/, "");
  var params = {};
  if (!locationHash.length) {
    return params;
  }
  if (locationHash.indexOf("=") < 0 && locationHash.indexOf("?") < 0) {
    params._path = urlSafeDecode(locationHash);
    return params;
  }
  var qIndex = locationHash.indexOf("?");
  if (qIndex >= 0) {
    var pathParam = locationHash.substr(0, qIndex);
    params._path = urlSafeDecode(pathParam);
    locationHash = locationHash.substr(qIndex + 1);
  }
  var query_params = urlParseQueryString(locationHash);
  for (var k in query_params) {
    params[k] = query_params[k];
  }
  return params;
}

function urlParseQueryString(queryString) {
  var params = {};
  if (!queryString.length) {
    return params;
  }
  var queryStringParams = queryString.split("&");
  var i, param, paramName, paramValue;
  for (i = 0; i < queryStringParams.length; i++) {
    param = queryStringParams[i].split("=");
    paramName = urlSafeDecode(param[0]);
    paramValue = param[1] == null ? null : urlSafeDecode(param[1]);
    params[paramName] = paramValue;
  }
  return params;
}

function urlSafeDecode(urlencoded) {
  try {
    urlencoded = urlencoded.replace(/\+/g, "%20");
    return decodeURIComponent(urlencoded);
  } catch (e) {
    return urlencoded;
  }
}

function sessionStorageSet(key, value) {
  try {
    window.sessionStorage.setItem("__telegram__" + key, JSON.stringify(value));
    return true;
  } catch (e) {}
  return false;
}

function sessionStorageGet(key) {
  try {
    return JSON.parse(window.sessionStorage.getItem("__telegram__" + key));
  } catch (e) {}
  return null;
}
